export default __webpack_public_path__ + "static/media/m29.b25b5c1f.jpg";